import React from "react";
import type { PropsWithChildren } from "react";

import { horizontalProductCardFooter } from "./HorizontalProductCard.css";

export const HorizontalProductCardFooter: React.FC<PropsWithChildren> = ({
  children
}) => {
  return <div className={horizontalProductCardFooter}>{children}</div>;
};
